import useSiteConfig, { SiteConfigLink } from '@components/Hooks/useSiteConfig';
import Icon from '@Shared/Icon';
import React from 'react';

const Docs: React.FC = () => {

  const config = useSiteConfig();

  const toListItem = (item: SiteConfigLink) => {
    return (
      <li key={item.title} style={{ padding: '7px 0 6px 16px', borderLeft: '1px solid #dddde8' }}>
        <a href={item.href} style={{ display: 'block' }} {...item.props}>
          <span className='fa-li' style={{ left: '-3em' }} >
            <Icon
              name={item.icon}
              style={{ color: item.color }}
              size='lg'
            />
          </span>
          {item.title}
        </a>
      </li>
    );
  }

  return (
    <div id="info-list" style={{ marginLeft: 2 }}>
      <ul className='fa-ul'>
        {config?.links.map(toListItem)}
      </ul>
    </div>
  );

}

export default Docs;